<script lang="ts">
	//Helpers
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_component_from_category,
		real_id,
	} from '../../../../helpers/interface_helpers';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Radio, toast } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device;

	const types = ['on', 'off', 'restore_last'];
	const types_translated = [
		$format('power_on_default_on'),
		$format('power_on_default_off'),
		$format('power_on_default_last'),
	];

	const defaultOptionsNewLayout = [
		{
			title: $format('power_on_default_on_new_layout_title', {
				default: 'Turn on',
			}),
			description: $format('power_on_default_on_new_layout_description', {
				default: 'Automatically turns the device on when power is restored.',
			}),
		},
		{
			title: $format('power_on_default_off_new_layout_title', {
				default: 'Turn off',
			}),
			description: $format('power_on_default_off_new_layout_description', {
				default: 'Keeps the device off when power is restored.',
			}),
		},
		{
			title: $format('power_on_default_last_new_layout_title', {
				default: 'Restore last state',
			}),
			description: $format('power_on_default_last_new_layout_description', {
				default: 'Returns the device to its previous state when power is restored.',
			}),
		},
	];
	const id = real_id(device.id);

	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;
	const structure = get_gen_2_component_channel_structure(device);
	let selected = settings?.[structure].initial_state;
	let cache = selected;
	let loading = false;

	const setDefault = async (state) => {
		selected = state;
	};
	const sentRequest = async () => {
		if (cache !== selected) {
			loading = true;
			const params = {
				id: device.channel,
				config: { initial_state: selected },
			};

			const res: SettingRequest = await gen2Request(
				device,
				`${get_gen_2_component_from_category(device)}.SetConfig`,
				params,
			);

			if (res.isok) {
				settings[structure].initial_state = selected;
				toast.open({
					type: 'success',
					title:
						$format('power_on_default_scc_toast') || `Power on was changed to ${selected}.`,
				});
				devices_settings.update_devices_settings(id, settings);
				cache = selected;
			} else {
				toast.open({ type: 'danger', title: $format('error_global') });
				selected = cache;
			}
			loading = false;
		}
	};
</script>

{#if $showNewLayout}
	{#each types as type, i}
		<Radio
			class="mb-s"
			size="m"
			{selected}
			value={type}
			on:click={() => setDefault(type)}
			id={`power-on-${type}`}
			info={defaultOptionsNewLayout[i].description}
		>
			{defaultOptionsNewLayout[i].title}
		</Radio>
	{/each}
{:else}
	{#each types as type, i}
		<Radio size="m" {selected} value={type} on:click={() => setDefault(type)} id="radio-phew232"
			>{types_translated[i]}</Radio
		>
	{/each}
{/if}
<Button class={$showNewLayout ? 'mt-m' : 'mt-s'} {loading} size="m" width="full" on:click={sentRequest}
	>{$format('button_save')}</Button
>
